import React from 'react';
import { IconSize, IconsFolderL1, IconsSubFolder, ImageWithFallbackCommonProps } from '../../types';
import ImageWithFallback from '../ImageWithFallback';

interface IconProps
  extends Partial<Pick<ImageWithFallbackCommonProps, 'fallback' | 'wrapperStyles' | 'idPrefix' | 'altText'>> {
  folder?: IconsFolderL1;
  subfolder?: IconsSubFolder;
  fullPath?: string;
  size: IconSize;
  simpleColorMask?: {
    color: string;
    size: number | string;
    borderRadius?: string;
  };
}

/**
 * Wrapper extending ImageWithFallback, renders an Icon, takes care of the media folder prefix and px.svg suffix.
 * @param folder - folder in https://github.com/askporter/media/tree/main/media/icons defaults to system
 * @param subfolder - sub-folder(s)
 * @param fullpath - the full icon path excluding(usually from API responses), if this is is truthy then it will take
 * precedence and both folder & subfolder will not be used
 * @param size - IconSize types, e.g. SM, MD or LG
 * @param simpleColorMask - simple entry for color mask, more advanced requirements can be met using ImageWithFallbackprops
 */
const Icon: React.FC<IconProps> = ({
  folder = 'system',
  subfolder,
  fullPath,
  size,
  simpleColorMask,
  ...rest
}: IconProps) => {
  const mask = simpleColorMask
    ? {
        // where the color is not returned by the server, we want to ensure the background is defaulted
        wrapperStyles: {
          height: simpleColorMask.size,
          width: simpleColorMask.size,
          backgroundColor: simpleColorMask.color ? undefined : 'background.default',
          borderRadius: simpleColorMask?.borderRadius || '4px',
        },
        colorMask: {
          height: simpleColorMask.size,
          width: simpleColorMask.size,
          color: simpleColorMask.color,
          borderRadius: simpleColorMask?.borderRadius || '4px',
        },
      }
    : {};

  return (
    <ImageWithFallback
      mode="icon"
      imagePath={fullPath ? `${fullPath}${size}px.svg` : `/media/icons/${folder}/${subfolder}/${size}px.svg`}
      size={size}
      altText=""
      {...mask}
      {...rest}
    />
  );
};

export default Icon;
